<template>
  <section id="something-else">
    <router-link id="link_something-else_damaged" to="/something-else/damaged">Report damage to my customer's property</router-link>
    <router-link id="link_something-else_feedback" to="/something-else/feedback">Provide feedback on my customer's delivery experience</router-link>
    <router-link id="link_something-else_critical" v-if="!this.isReturnBarcode()" to="/something-else/critical">I need to report a critical issue</router-link>
    <router-view></router-view>
  </section>
</template>

<script>
import trackingJS from '../helpers/tracking.js';

export default {
  mixins: [trackingJS]
}
</script>


// WEBPACK FOOTER //
// src/components/sections/SomethingElse.vue